export default __webpack_public_path__ + "static/notebook_icon-e3a917e4244bd0944f870640c8cb6b77.png";